import {
  Component,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  EventEmitter,
  ChangeDetectionStrategy,
  Inject,
  OnChanges,
} from "@angular/core";
import { MatDialog, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { UserService } from "src/app/core/services/v2/user.service";
import { PhysicianOptionService } from "src/app/physician/shared/physician-option/physician-option.service";
import { PhysicianReviewComponent } from "src/app/physician/shared/physician-review/physician-review.component";
import { debug } from "util";
import { ReviewDetail } from "../../../core/model/v2/review/review-detail";
import { ReviewService } from "../../../core/services/v2/review-service";
import { ReviewSummary } from "src/app/core/model/v2/review/review-summary";
import { Practitioner } from "src/app/core/model/v2/practitioner/practitioner";
import { AddPhysiciansDialogComponent } from "../add-physicians-dialog/add-physicians-dialog.component";
import { ConfirmDeleteDialogComponent } from "../confirm-delete-dialog/confirm-delete-dialog.component";
//import { WindowLoaderService } from "../window-loader/window-loader.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { EditPracticeComponent } from "./edit-practice/edit-practice.component";
import { Review } from "../../../core/model/v2/review/review";
import { tr } from "date-fns/esm/locale";
import { ChangeDetectorRef } from "@angular/core";
import { decode } from "punycode";
import { GeoLocationService } from "../../../core/services/v2/geolocation.service";
import { MapLocation } from "../../../core/models/google-map-marker";

@Component({
  selector: "app-profile-layout",
  templateUrl: "./profile-layout.component.html",
  styleUrls: ["./profile-layout.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileLayoutComponent implements OnInit, OnChanges {
  @Input() profileData;
  @Input() reviewData;
  @Input() reviewDetail;
  @Input() isLoggedIn;
  @Input() userId;
  parentProfileData: any;
  DetailProfessional: any;
  practitionerId: number;
  rvSummary: any;
  reviewSummary: ReviewSummary;
  practitionerData: Practitioner;
  details: ReviewDetail;
  initials: any;
  toggleDayOffSidebar: boolean;
  showFiller = false;
  sectionName: string;
  sideBarHeader: string;
  toggleSidebar = false;
  childComponent: EditPracticeComponent;
  selectedFile = null;
  @Output() dataRefresh = new EventEmitter();
  isTimingEdit: boolean = false;
  toggleName: string;
  loggedPractitionerId: number;
  categorySelected: string = "About";
  medicationerDetail = {};
  licenserDetail = {};
  uaction: string = "";
  id: number;
  npi: number;
  src: string = "";
  patientId: number;
  canEditPractitioner: boolean;
  managelbltxt: string = "Manage";
  cardEntries: any;
  isPractitioner: boolean = false;

  /* Menu options flags */
  isAbout: boolean = true;
  isTreatments: boolean = true;
  isPracticeTreatments: boolean = true;
  isServices: boolean = false;

  //isPractitioner: boolean = true;
  isPracticeLocation: boolean = true;
  isPhysicians: boolean = true;
  isApp: boolean = true;
  isLicensed: boolean = true;
  isMedical: boolean = true;
  isInsurance: boolean = true;
  isPractitionerInsurance: boolean = false;
  isPersonalContact: boolean = true;
  isRegistrationDocument: boolean = true;
  isHospitalAffiliation: boolean = true;
  isRatingReview: boolean = true;
  isPracticeServices: boolean = true;
  breadcrumb = [];
  isFromProfileLayout: boolean = false;
  practitionerTreatLists = [];
  currentLocation: MapLocation;
  private ratingFullImage = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill text-warning" viewBox="0 0 16 16"><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/></svg>`;
  private ratingHalfImage = `<svg class="bi bi-star-fill text-warning half-star" width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.53834 0.609964C8.70914 0.199318 9.29086 0.199318 9.46166 0.609964L11.5278 5.57744C11.5998 5.75056 11.7626 5.86885 11.9495 5.88383L17.3123 6.31376C17.7556 6.3493 17.9354 6.90256 17.5976 7.19189L13.5117 10.6919C13.3693 10.8139 13.3071 11.0053 13.3506 11.1876L14.5989 16.4208C14.7021 16.8534 14.2315 17.1954 13.8519 16.9635L9.26063 14.1592C9.10062 14.0615 8.89938 14.0615 8.73937 14.1592L4.14806 16.9635C3.76851 17.1954 3.29788 16.8534 3.40108 16.4208L4.64939 11.1876C4.69289 11.0053 4.6307 10.8139 4.48831 10.6919L0.402413 7.19189C0.0646446 6.90256 0.244408 6.3493 0.687735 6.31376L6.05054 5.88383C6.23744 5.86885 6.40024 5.75056 6.47225 5.57744L8.53834 0.609964Z" fill="#FDB022"/></svg>`;
  private ratingBlankImage = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.53834 1.10996C8.70914 0.699318 9.29086 0.699318 9.46166 1.10996L11.5278 6.07744C11.5998 6.25056 11.7626 6.36885 11.9495 6.38383L17.3123 6.81376C17.7556 6.8493 17.9354 7.40256 17.5976 7.69189L13.5117 11.1919C13.3693 11.3139 13.3071 11.5053 13.3506 11.6876L14.5989 16.9208C14.7021 17.3534 14.2315 17.6954 13.8519 17.4635L9.26063 14.6592C9.10062 14.5615 8.89938 14.5615 8.73937 14.6592L4.14806 17.4635C3.76851 17.6954 3.29788 17.3534 3.40108 16.9208L4.64939 11.6876C4.69289 11.5053 4.6307 11.3139 4.48831 11.1919L0.402413 7.69189C0.0646446 7.40256 0.244408 6.8493 0.687735 6.81376L6.05054 6.38383C6.23744 6.36885 6.40024 6.25056 6.47225 6.07744L8.53834 1.10996Z" fill="#F3F4F6" /></svg>`;
  testimonialData;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private _practiceService: PracticeService,
    private userService: UserService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: WindowLoaderService,
    private practiceService: PracticeService,
    private reviewService: ReviewService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private physicianOptionService: PhysicianOptionService,
    private changeDetectorRef: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private locationService: GeoLocationService
  ) {

    this.matIconRegistry.addSvgIcon(
      "calendar-clock",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "/app/assets/icons/Calendar&Clock.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "circle-star",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "/app/assets/icons/circleStar.svg"
      )
    );
  }
  ngOnChanges() {
    //this.breadcrumb = [];
    //if (this.breadcrumb.indexOf("Practice") == -1) {
    //  this.breadcrumb.push("Practice");
    //}
    
    if (this.profileData != undefined) {
      this.getPractitionerList();
      this.parentProfileData = this.profileData;
    }
    if (
      this.profileData != undefined && this.profileData.fullName != "" &&
      this.profileData.fullName != undefined
    ) {
      this.initials =
        this.profileData.fullName
          .split(" ")[0]
          .substring(0, 1)
          .toUpperCase() +
        this.profileData.fullName
          .split(" ")
        [this.profileData.fullName.split(" ").length - 1].substring(0, 1)
          .toUpperCase();
    } else {
      this.initials =
        ((this.profileData != undefined && this.profileData.firstName != undefined) ? this.profileData.firstName.substring(0, 1).toUpperCase() : "") +
        ((this.profileData != undefined && this.profileData.lastName != undefined) ? this.profileData.lastName.substring(0, 1).toUpperCase() : "");
    }
  }
  ngOnInit() {
    
    this.breadcrumb = [];
    this.getParams();
    if (this.src == "overview") {
      this.breadcrumb.push("Practitioner");
      if (this.patientId > 0) {
        this.cardSelection("Professional1", null, this.id, "Patient");
      }
      else {
        this.cardSelection("Professional1", null, this.id, "Physician");
      }
      
    }
    else {
      this.breadcrumb.push("Practice");
    }
    this.showHideMenuOptions();
    // this.categorySelected = fals;
    this.loaderService.show();
    
    this.userService.getUserDetails().subscribe(
      (userData) => {
        this.loggedPractitionerId = userData.practitionerId;
        if (this.id) {

          if (
            this.loggedPractitionerId == this.id ||
            userData.managedPractitionerIds.indexOf(this.id) >= 0 || userData.isGlobalAdministrator

          ) {
            this.canEditPractitioner = true;
          } else {
            this.canEditPractitioner = false;
          }
          // this.getDetailsById(this.id);
        } else if (this.npi) {
          this.canEditPractitioner = false;
          // this.getDetailsByNpi(this.npi);
        } else {
          //else is the profile of gim self
          this.canEditPractitioner = true;
          // this.getDetailsById(this.loggedPractitionerId);
        }
        this.changeDetectorRef.detectChanges();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );

    this.locationService.getPosition().then((pos) => {
      this.currentLocation = { lat: pos.lat, lng: pos.long };
    }).catch((err) => {
      alert('Please enable location and refresh again to get accurate data for this page.');
    })

  }

  getParams() {
    let decodedURI = decodeURIComponent(window.location.href);
    if ((window.location.href.indexOf("%")) > -1) {
      this.getEncodedUrlParams(decodedURI);
    }
    else {
      this.route.params.subscribe(
        (params) => {
          this.id = +params["id"];
          this.npi = params["npi"];
          this.src = params["src"];
          this.patientId = params["patientId"];
          // this.hsid = params["hsid"]
        },
        (error) => {
          console.error(error);
        }
      );
    }
 
    if (this.src) {
      this.categorySelected = "Professional1";
      this.cardSelection(this.categorySelected, this.profileData != null ? this.profileData.practitionerDetails : null, this.id, "Physician");
    }
  }

  getEncodedUrlParams(encodedUrl) {
    let decodedURI = decodeURIComponent(window.location.href);
    let backSlashIndex = decodedURI.lastIndexOf("/");
    let paramStr = decodedURI.substring(backSlashIndex);
    let arrparams = paramStr.split(";");
    arrparams.forEach(x => {
      if (x.indexOf("=") > -1) {
        if (x.indexOf("hsid")==-1 && x.indexOf("id") > -1) {
          this.id = Number(x.split("=")[1]);
        }
        if (x.indexOf("npi") > -1) {
          this.npi = Number(x.split("=")[1]);
        }
        if (x.indexOf("src") > -1) {
          this.src = x.split("=")[1];
        }
      }

    });
  }
  countArray(n: Number) {
    let count = [];
    for (let i = 0; i < n; i++) {
      count[i] = i;
    }
    return count;
  }

  filterByRole(item, type) {

    return item ? item.filter((x) => x.roleCategory === type) : item;

  }
  filterById(item, pId, type) {

    // this.DetailProfessional = item.filter((x) => x.roleCategory === type && x.id == pId);

    this.getDetailsById(pId);

  }
  getAge(year: Date) {
    var today = new Date();
    var birthDate = new Date(year);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  toggleEditSidebar(eve) {
    this.toggleName = eve;
    this.toggleSidebar = !this.toggleSidebar;
    if (!this.toggleSidebar) {
      this.dataRefresh.emit();
    }
    this.showHideScroll(this.toggleSidebar);
  }

  showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector("body");
    if (isOpen) {
      body.style.cssText = "height:100vh; overflow:hidden";
    } else {
      body.style.cssText = "height:auto; overflow:visible";
    }
  }

  addFavorite() {
    const physicianFav = {
      practitionerId: this.physicianOptionService.getPhysician().id,
      favoriteId: this.profileData.id,
      favoriteNpi: this.profileData.npi,
      favoritesTypeId: 1,
    };
    this._practiceService.addPractitionerFavorites(physicianFav).subscribe(
      (_) => {
        this.profileData.isFavorite = true;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  openReviewDetail(): void {
    const dialogref = this.dialog.open(PhysicianReviewComponent, {
      width: "40vw",
      data: this.reviewData,
    });
  }

  uploadFile(event: any) {

    this.selectedFile = event.target.files[0];
    const payload: FormData = new FormData();
    const self = this;

    if (this.profileData.role) {
      payload.append("PractitionerId", this.profileData.id.toString());
      payload.append("ImageSource", this.selectedFile);
      this._practiceService.uploadtProfilePicture(payload).subscribe(
        (res) => {
          if (res.isSuccess) {
            this.dataRefresh.emit();
          }
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      payload.append("HealthSystemId", this.profileData.id.toString());
      payload.append("ImageSource", this.selectedFile);
      this._practiceService.uploadHealthSystemProfilePicture(payload).subscribe(
        (res) => {
          if (res.isSuccess) {
            this.dataRefresh.emit();
          }
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }


  categorySelection(catval: string, isEditAbout?: boolean) {
    if (this.breadcrumb.length > 1) {
      this.breadcrumb.splice(1, this.breadcrumb.length);
    }
    if (this.breadcrumb.indexOf(catval) == -1) {
      this.breadcrumb.push(catval);
    }

    this.categorySelected = catval;
    this.uaction = "";
    this.managelbltxt = "Manage";
    if (isEditAbout) {

      this.categorySelected = "About";
      this.dataRefresh.emit();
    }
    if (this.categorySelected == "Conditions") {
      this.isPractitioner = true;
    }
    else {
      this.isPractitioner = false;
    }
    //this.loaderService.hide();
    this.showHideMenuOptions();
  }
  cardSelection(catval: string, item: any, pId: number, type: string) {
    this.breadcrumb = [];
    this.breadcrumb.push("Practitioner");

    this.categorySelected = catval;
    this.loaderService.show();

    switch (type) {
      case "Physician":
        this.isPractitioner = true;
        this.isFromProfileLayout = true;
       // this.router.navigate(["/physician/profile/profilelocation/" + this.id, { id: element.practitioner.id, src: "overview", hsid: this.selectedHealthSystem.id }]);
     
        break;
      case "App":
        this.isPractitioner = true;
        this.isFromProfileLayout = true;
        break;
      case "Medical Professional":
        this.isPractitioner =
          this.isFromProfileLayout = true; true;
        break;
      case "Licensed Professional":
        this.isPractitioner =
          this.isFromProfileLayout = true; true;
        break;
      default:
        this.isPractitioner = false;
        break;
    }
    this.showHideMenuOptions();

    this.filterById(item, pId, type);
  }
  processAction(puaction: string) {

    this.uaction = puaction;
    if (this.uaction == "edit") {
      this.managelbltxt = "Add";
    }
    else {
      this.managelbltxt = "Manage";
    }
  }
  stopLoader() {
    this.loaderService.hide();
  }
  getRatings(rating: number) {
    let hasDecimalValue = !Number.isInteger(rating);
    let loopVal = Math.floor(rating);
    let ratingsHtml = '';

    if (rating == 0) {
      for (let index = 0; index < 5; index++) {
        ratingsHtml += this.ratingBlankImage;
      }
    } else {
      for (let index = 0; index < loopVal; index++)
        ratingsHtml += this.ratingFullImage;

      if (hasDecimalValue)
        ratingsHtml += this.ratingHalfImage;
    }

    if (loopVal > 0 && loopVal < 5) {
      let blankStars = 5 - loopVal;
      for (let index = 0; index < blankStars; index++) {
        ratingsHtml += this.ratingBlankImage;
      }
    }

    return this.domSanitizer.bypassSecurityTrustHtml(ratingsHtml);
  }
  getReviewDetail(npi: string): Observable<ReviewDetail> {
    const obs = new Observable<ReviewDetail>((observer) => {
      this.loaderService.show();
      this.reviewService.getReviewDetail(npi).subscribe(
        (details) => {
          this.loaderService.hide();
          if (details) {
            observer.next(details);
          }
          observer.complete();
        },
        (error) => {
          observer.error(error);
          this.loaderService.hide();
        }
      );
    });
    return obs;
  }

  async getDetailsById(practitionerId: number) {

    this.loggedPractitionerId = practitionerId;
    this.practitionerId = this.loggedPractitionerId;
    var self = this;
    self.loaderService.show();

    await self.practiceService.getPractitionerDetails(practitionerId).subscribe(
      (practitionerData) => {
        self.DetailProfessional = practitionerData;
        self.profileData = practitionerData; //For showing practitioner data instead of hospital data.

        console.log("PRACTITONER DATA LAYOUT PAGE: ", self.DetailProfessional);
        self.getReviewDetail(practitionerData.npi).subscribe((details) => {
          self.testimonialData = details;

          self.details = null;
          self.details = details ? details
            : new ReviewDetail();
          self.details.oneStar = self.details.oneStar ? (self.details.oneStar = Math.random()) : self.details.oneStar;
        });

        self.practitionerData = null;
        self.practitionerData = practitionerData
          ? practitionerData
          : new Practitioner();
        self.practitionerData.photoUrl = self.practitionerData.photoUrl
          ? (self.practitionerData.photoUrl += "?" + Math.random())
          : self.practitionerData.photoUrl;
        self.getReviewSummary(practitionerData.npi).subscribe();
        console.log("PRACTITONER DATA LAST: ", practitionerData);


      },
      (error) => {
        self.profileData = self.DetailProfessional;
        console.error(error);
        self.loaderService.hide();
      },
      () => {
        self.loaderService.hide();

        self.profileData = self.DetailProfessional;
      }
    );

  }

  getReviewSummary(npi: string): Observable<void> {
    const obs = new Observable<void>((observer) => {
      this.reviewService.getReviewSummary(npi).subscribe(
        (summary) => {
          if (summary) {
            this.reviewSummary = summary;
          }
          observer.next();
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
    return obs;
  }
  deletePhysician(phyID: number) {

    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: "400px",
      height: "268px",
      data: { entryId: phyID, confirmTitle: "Remove Physician", confirmDescription: "Are you sure you want to delete this physician? You can add it again if needed.", noButtonTitle: "No", yesButtonTitle: "Yes" }

    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          console.log("Delete was successfull.")
          // this.deactivateReferral(result);
        }
      },
      (error) => { console.error(error); });
  }

  addPhysicians() {
    const dialogRefAdd = this.dialog.open(AddPhysiciansDialogComponent, {
      width: "520px",
      height: "90%",
      data: { entryId: 0 }

    });

    dialogRefAdd.afterClosed().subscribe(
      (result) => {
        if (result) {
          console.log("Add was successfull.")
          // this.deactivateReferral(result);
        }
      },
      (error) => { console.error(error); });

  }
  showHideMenuOptions() {
    /* let isPractice = this.breadcrumb.indexOf("Practice") != -1 ? true : false;*/
    if (this.categorySelected == "Professional1" || this.categorySelected == "Personal Contact" || this.categorySelected == "Treatments"
      || this.categorySelected == "Services" || this.categorySelected == "Conditions" || this.categorySelected == "RegistrationDocuments" ||
      this.categorySelected == "HospitalAffiliations" || this.categorySelected == "RatingReview"
      || this.categorySelected == "PracticeLocation" || this.categorySelected == "Insurance Accepted") {
      this.isServices = true;
      this.isTreatments = true;
      this.isPracticeTreatments = false;
      this.isPractitioner = true; //For condition menu option
      this.isPersonalContact = true;
      this.isRegistrationDocument = true;
      this.isHospitalAffiliation = true;
      this.isRatingReview = true;
      this.isPracticeLocation = true;
      this.isAbout = false;
      this.isPracticeServices = false;
      this.isPhysicians = false;
      this.isApp = false;
      this.isLicensed = false;
      this.isMedical = false;
      this.isInsurance = true;

    }
    else {
      this.profileData = this.parentProfileData;
      this.isPractitioner = false;
      this.isServices = false;
      /* Menu options flags */
      this.isAbout = true;
      this.isPracticeServices = true;
      this.isTreatments = false;
      this.isPracticeTreatments = true;
      //isPractitioner = true;  
      this.isPhysicians = true;
      this.isApp = true;
      this.isLicensed = true;
      this.isMedical = true;
      this.isInsurance = true;
      this.isPracticeLocation = false;
      this.isPersonalContact = false;
      this.isRegistrationDocument = false;
      this.isHospitalAffiliation = false;
      this.isRatingReview = false;
      this.isRatingReview = false;

    }

  }
  reloadProfile(profileDataVal: any) {

    this.profileData = profileDataVal;
    this.changeDetectorRef.detectChanges();
  }
  async getPractitionerList() {
    var self = this;
    if (self.profileData && this.profileData.practitionerDetails && self.profileData.practitionerDetails.length > 0) {
      for (let i = 0; i < self.profileData.practitionerDetails.length; i++) {
        await self.practiceService.getPractitionerDetails(self.profileData.practitionerDetails[i].id).subscribe(
          (practitionerData) => {
           // let pdata = practitionerData;
            if (self.profileData.practitionerDetails != undefined) {
              self.practitionerTreatLists[i] = { 'Name': self.profileData.practitionerDetails[i].fullName, 'treatmentType': practitionerData }
            }
            
          });
      }
    }
  }


  async showPracticePage(id: any) {
    
    await this.getHSDetailsById(id);

  }

  getHSDetailsById(healthsystemId: number) {

    this._practiceService.gethealthSystemDetails(healthsystemId).subscribe(
      (practicelocationData) => {
        
        this.profileData = practicelocationData;
        this.categorySelection('About');
        this.getReviewSummary(this.profileData.npi).subscribe();

        this.loaderService
          .blockWithLoader(
            this._practiceService.gethealthSystemServices(healthsystemId)

          )
          .subscribe(
            (list) => {
              if (list.resultStatus.isSuccess) {
                this.profileData.healthSystemServices = list.result;
              } else {
                console.error(list);
                this._snackBar.open(
                  `Error when retrieving services list: ${list.resultStatus.message}`,
                  "Ok"
                );
              }
            },
            (error) => {
              console.error(error);
              this._snackBar.open(
                `Services could not be retrieved${error.error && error.error.resultStatus
                  ? ": " + error.error.resultStatus.message
                  : ""
                }`,
                "Ok",
                {
                  duration: 5000,
                }
              );
            }
          );
      },
      (error) => {
        console.error(error);
      }
    );
    this.changeDetectorRef.detectChanges();
  }

  redirectToProfile(element) {
    this.router.navigate(["/physician/profile/profilelocation/" + this.profileData.id.toString(), { id: element.id, src: "overview", hsid: this.profileData.id.toString() }]);
  }
  openDirection() {
    let url = `https://www.google.com/maps/dir/?api=1&origin=${this.currentLocation.lat},${this.currentLocation.lng}&destination=${this.profileData.location.latitude},${this.profileData.location.longitude}&travelmode=driving`
    window.open(url, "_blank");
  }


}
